module.exports = __webpack_public_path__ + "img/tim.e78095b5.jpg";